<template>
<div id="wrapper" class="wrapper haslayout">
  <WebPortalHeader />
  <main id="" class="webportal_home haslayout">
    <!--************************************
                DGME links Start
            *************************************-->
    <section class="st-shape-wrap">
      <div class="container-fluid">
        <div class="row" id="designedBackground">
          <div class="webportal-contant">
            <LeftSlider />
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class="row">
                <div class="mid_contant">
                  <div
                    class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12 mt-5"
                  >
                    <div class="row" id="notice-board">
                      <div class="notice-board-bg">
                        <!-- {{getPortalPublicData.notice}} -->
                        <h2>NOTICE BOARD</h2>
                        <div id="notice-board-ticker">
                          <ul class="caption">
                            <li
                              v-for="(
                                item, index
                              ) in getAllPortalNotice"
                              :key="index"
                            >
                              <a @click="noticeMethod(item)">{{
                                item.title
                              }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <v-pagination
                      v-model="pagination.page"
                      class="my-4"
                      :length="paginationTotalPage"
                      total-visible="7"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
            <RightSlider />
          </div>
        </div>
      </div>
      <div class="st-shape2">
        <img src="../../assets/images/contact-shape1.svg" alt="shape2" />
      </div>
    </section>
    <!--************************************
                DGME links Start
            *************************************-->
  </main>
  <WebPortalFooter />
</div>
</template>

<script>
import WebPortalHeader from "../../components/webPortalLayout/WebPortalHeader.vue";
import LeftSlider from "../../components/webPortalLayout/LeftSlider";
import RightSlider from "../../components/webPortalLayout/RightSlider";
import WebPortalFooter from "../../components/webPortalLayout/WebPortalFooter";

export default {
  components: {
    WebPortalHeader,
    LeftSlider,
    RightSlider,
    WebPortalFooter,
  },
  data(){
    return {
      pagination: {
        page: 1,
        size: 20,
      },
      paginationTotalPage: null,
    }
  },
  async created() {
    ////  console.log(height);
    this.$store.dispatch("callHeaderFooterPublicData");
  },
  async mounted() {
    await this.searchAllNotice();
    let heights = window.innerHeight;
    // document.getElementById('designedBackground').style.height = heights + "px";
  },
  computed: {
    getAllPortalNotice() {
      return this.$store.getters.getPortalAllNoticeList;
    },
  },
  watch: {
    pagination: {
      handler(val){
        this.searchAllNotice();
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    noticeMethod(val) {
      this.$router.push(`/notice-details/${val.id}`);
    },
    async searchAllNotice(){
      return this.$store.dispatch("callPortalAllNoticeList", {
        page: this.pagination.page,
        size: this.pagination.size
      }).then((result)=>{
        return this.paginationTotalPage = Math.ceil(result/this.pagination.size);
      });
    }
  },
};
</script>

<style scoped>
.row {
  display: block;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
</style>
